import { useCallback, useState } from 'react';
import './dashboardNavItem.scss';
import { Select } from '../Input';
import useIsAdmin from '../../hooks/useIsAdmin';
import { icons } from '../../assets';


const DashboardNavItem = ({ navItems, tab, setTab, isSecondTier, navItemsObj, dontShowWithdraw, filterable = true }: {
  navItems: Array<string>;
  tab: string;
  setTab: (val: string) => void;
  isSecondTier?: boolean;
  navItemsObj?: Array<Record<string, any>>;
  dontShowWithdraw?: boolean;
  filterable?: boolean
}) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const isAdmin = useIsAdmin();

  const handleClick = useCallback((item) => {
    setTab(item);
    showDropDown && setShowDropDown(false);
  }, [showDropDown, setTab]);

  if (isSecondTier) {
    return (
      <div className='filter-wrapper flex-wrap my-0 !h-fit py-5'>
        {
          !isAdmin && (
            <>
              {/* <input type="" className='h-10 border border-gray-300 w-96 px-4 my-4' placeholder='Search' /> */}
              {
                filterable && (
                  <div className='flex flex-row w-auto justify-around items-center my-0'>
                    <div className='flex flex-row justify-between items-center w-auto'>
                      <label htmlFor="" className='mr-4 w-[100px]'>Filter by:</label>
                      <Select
                        name="filter"
                        label=''
                        data={navItems}
                        onChange={(field, value) => {
                          setTab(value);
                        }}
                        value={tab}
                        selectClassName='!bg-gray-300'
                      />
                    </div>
                  </div>
                )
              }

            </>
          )
        }

      </div>
    )
  }
  if (navItemsObj) {
    return (
      <div className="!w-fit min-h-10 flex flex-row flex-wrap gap-y-2 ">
        {
          navItemsObj.map((itm, index) => {
            if (itm.renderer) {
              return itm.renderer();
            }
            return (
              <button
                key={`${index}-${itm.label}`}
                disabled={itm.disabled}
                className={`text-white px-4 ml-4 flex flex-row w-fit justify-around items-center h-10 capitalize ${itm.active ? 'animate-pulse' : ''}`}
                onClick={itm.action} style={{ background: itm.bgColor }}>
                <img src={itm.img} alt="" className='mr-2 w-[20px] rounded-full' />
                {itm.label}
                {itm.renderItem && itm.renderItm()}
              </button>
            )
          })
        }
      </div>
    )
  }
  return (
    <ul className="sub-nav dashboard-nav">
      <img
        src={showDropDown ? icons.closeIcon : icons.menu}
        alt="options"
        className="nav-menu"
        onClick={() => setShowDropDown(!showDropDown)}
      />
      {
        navItems.map((item) => (
          <li key={item} className={item === tab ? 'selected' : ''} onClick={() => handleClick(item)}>
            {item}
          </li>
        ))
      }
      {
        showDropDown && (
          <div className='subnav-dropdown'>
            {
              navItems.map((item) => (
                <li key={item} className={item === tab ? 'selected' : ''} onClick={() => handleClick(item)}>
                  {item}...
                </li>
              ))
            }
          </div>
        )
      }
    </ul>
  )
}

export default DashboardNavItem;
